module.exports = __webpack_public_path__ + "img/issue_age_filled.6930b3b.svg";